import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Attendance from "./pages/Attendance";
import Recap from "./pages/Recap";
import Teachers from "./pages/Teachers";
import Schools from "./pages/Schools";
import Rates from "./pages/Rates";
import Users from "./pages/Users";
import AuditLog from "./pages/AuditLog";
import Profile from "./pages/Profile";
import Placeholder from "./pages/Placeholder";
import TeachingFee from "./pages/TeachingFee";
import Income from "./pages/Income";
import Expenses from "./pages/Expenses";
import SlipGaji from "./pages/SlipGaji";
import Reports from "./pages/Reports";
import TeacherHome from "./pages/TeacherHome";
import MyClasses from "./pages/MyClasses";
import ClassStudents from "./pages/ClassStudents";
import ClassScores from "./pages/ClassScores";
import ClassRecap from "./pages/ClassRecap";
import StudentReport from "./pages/StudentReport";
import ClassReports from "./pages/ClassReports";
import AssignmentGuru from "./pages/AssignmentGuru";
import { useAuth } from "./context/AuthContext";
import { Loader2 } from "lucide-react";

const BM = ["branch_manager"];
const ALL = ["branch_manager", "coordinator"];
const LAYOUT = ["branch_manager", "coordinator", "teacher"];
const TEACHER = ["teacher"];

function RoleLanding() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gtscream">
        <Loader2 className="w-8 h-8 text-gtsorange animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "teacher" ? "/teacher" : "/dashboard"} replace />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<ProtectedRoute roles={LAYOUT}><Layout /></ProtectedRoute>}>
        <Route path="/teacher" element={<ProtectedRoute roles={TEACHER}><TeacherHome /></ProtectedRoute>} />
        <Route path="/classes" element={<ProtectedRoute roles={LAYOUT}><MyClasses /></ProtectedRoute>} />
        <Route path="/classes/:classId/students" element={<ProtectedRoute roles={LAYOUT}><ClassStudents /></ProtectedRoute>} />
        <Route path="/classes/:classId/scores" element={<ProtectedRoute roles={LAYOUT}><ClassScores /></ProtectedRoute>} />
        <Route path="/classes/:classId/recap" element={<ProtectedRoute roles={LAYOUT}><ClassRecap /></ProtectedRoute>} />
        <Route path="/classes/:classId/reports" element={<ProtectedRoute roles={LAYOUT}><ClassReports /></ProtectedRoute>} />
        <Route path="/students/:studentId/report" element={<ProtectedRoute roles={LAYOUT}><StudentReport /></ProtectedRoute>} />
        <Route path="/assignments" element={<ProtectedRoute roles={BM}><AssignmentGuru /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute roles={ALL}><Dashboard /></ProtectedRoute>} />
        <Route path="/attendance" element={<ProtectedRoute roles={ALL}><Attendance /></ProtectedRoute>} />
        <Route path="/recap" element={<ProtectedRoute roles={ALL}><Recap /></ProtectedRoute>} />
        <Route path="/notes" element={<ProtectedRoute roles={ALL}><Attendance notesMode /></ProtectedRoute>} />
        <Route path="/profile" element={<Profile />} />
        {/* Branch manager only */}
        <Route path="/teachers" element={<ProtectedRoute roles={BM}><Teachers /></ProtectedRoute>} />
        <Route path="/schools" element={<ProtectedRoute roles={BM}><Schools /></ProtectedRoute>} />
        <Route path="/rates" element={<ProtectedRoute roles={BM}><Rates /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute roles={BM}><Users /></ProtectedRoute>} />
        <Route path="/audit" element={<ProtectedRoute roles={BM}><AuditLog /></ProtectedRoute>} />
        {/* Stage 3 finance (branch manager) */}
        <Route path="/teaching-fee" element={<ProtectedRoute roles={BM}><TeachingFee /></ProtectedRoute>} />
        <Route path="/income" element={<ProtectedRoute roles={BM}><Income /></ProtectedRoute>} />
        <Route path="/expenses" element={<ProtectedRoute roles={BM}><Expenses /></ProtectedRoute>} />
        {/* Stage 4 */}
        <Route path="/slips" element={<ProtectedRoute roles={BM}><SlipGaji /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute roles={BM}><Reports /></ProtectedRoute>} />
      </Route>
      <Route path="/" element={<RoleLanding />} />
      <Route path="*" element={<RoleLanding />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
